import DeleteIcon from "@mui/icons-material/Delete";
import { type SvgIconProps, styled } from "@mui/material";

const StyledDeleteIcon = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.error.dark,
}));

export const DangerDeleteIcon = ({ fontSize = "small", ...props }: SvgIconProps) => (
  <StyledDeleteIcon fontSize={fontSize} {...props} />
);
